import type {
  GTMEventGlycerinButtonClick,
  GTMEventGlycerinDisplayButton,
} from '@packages/tracking/src/types/events';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import { useRef } from 'react';

export const useShareButtonTracking = () => {
  const dispatchTracking = useTracking();
  const viewButtonTrackedRef = useRef(false);

  const trackButtonClick = () => {
    dispatchTracking<GTMEventGlycerinButtonClick>({
      event: 'ButtonClick',
      ButtonClickData: {
        category: 'ShareButton',
      },
    });
  };

  const trackViewButton = () => {
    if (viewButtonTrackedRef.current) return;
    viewButtonTrackedRef.current = true;
    dispatchTracking<GTMEventGlycerinDisplayButton>({
      event: 'DisplayButton',
      DisplayButtonData: {
        category: 'ShareButton',
      },
    });
  };

  return {
    trackButtonClick,
    trackViewButton,
  };
};
